export default __webpack_public_path__ + "assets/png/9d39b4f49408342e54ec740752998c30.png";